module.exports = __webpack_public_path__ + "static/img/car_front.9c724c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car_front.png
// module id = +88J
// module chunks = 1